import { monitoredReplace } from 'src/service/utils/sentry/navigation'

const AOS_APP_STORE_WARD = 'https://play.google.com/store/apps/details?id=co.kr.datau.tesla_p'
const IOS_APP_STORE_WARD = 'https://apps.apple.com/kr/app/%ED%9C%B4%EB%8C%80%ED%8F%B0%EA%B0%80%EC%A1%B1%EB%B3%B4%ED%98%B8-familycare-%EA%B0%80%EC%A1%B1-%EC%9C%84%EC%B9%98-%ED%99%95%EC%9D%B8/id6736891661'

export const deviceCheck = (): boolean | undefined => {
  const filter = 'win|win32|win64|mac|macintel'
  if (navigator.platform) return !filter.includes(navigator.platform.toLowerCase()) // mobile : pc
}
function deviceDetection() {
  const userAgent = navigator.userAgent.toLowerCase()
  const isIOS = /iphone|ipad|ipod/.test(userAgent)
  const isAndroid = /android/.test(userAgent)

  if (isIOS) {
    return 'IOS'
  } else if (isAndroid) {
    return 'AOS'
  } else {
    return 'WEB'
  }
}
export const guid = (): string => {
  function _p8 (s: any) {
    const p = (Math.random().toString(16) + '000000000').substr(2, 8)
    return s ? '-' + p.substr(0, 4) + '-' + p.substr(4, 4) : p
  }
  return _p8(false) + _p8(true) + _p8(true) + _p8(false)
}

export const formatPhoneNumber = (phoneNumber: string) => {
  return  '+82' + phoneNumber.slice(1, phoneNumber.length)
}

export const tryClose = () => {
  try {
    window.close()
  } catch {}

  if (window.opener && !window.opener.closed) {
    try {
      window.close()
    } catch {}
    return
  }

  if (window.history.length > 1) {
    window.history.back()
    setTimeout(() => {
      try {
        window.close()
      } catch {}
    }, 300)
    return
  }

  window.location.href = 'about:blank'
  setTimeout(() => {
    try {
      window.close()
    } catch {}
  }, 300)
}

export function redirectToStore() {
  switch (deviceDetection()) {
    case 'IOS':
      monitoredReplace(IOS_APP_STORE_WARD, 'redirectToStore')
      break
    case 'AOS':
    default:
      monitoredReplace(AOS_APP_STORE_WARD, 'redirectToStore')
      break
  }
  setTimeout(tryClose, 1000)
}
